(function($) {  
  
  let $shortcodeUC = $('.ShortCode.UserCourses')
  if($shortcodeUC.length) { 

    $shortcodeUC = $shortcodeUC.eq(0)
    $courses = $shortcodeUC.find('.ShortCode.ListCourses')
    $course = $courses.find('.Course')

    const $menuoptions = $shortcodeUC.find('.Menu .Options .Option')

    $menuoptions.each(function() {

      const $this = $(this)
      const option = $this.data('option')

      $this.on(
        'click',
        function() {

          const $this = $(this)

          $course.hide()
          $menuoptions.removeClass('Selected')
          $this.addClass('Selected')

          if(option == 'All') {

            $course.show()

          } else {

            /*
            console.log(option)
            console.log('.' + option)
            console.log($courses.find('.' + option))
            */

            $courses.find('.' + option).show()
          }

          return false;
        }
      )
    })
  }    

})(jQuery)